import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import * as urlParser from 'url-parse';
import * as qs from 'qs';
import Tooltip from '@material-ui/core/Tooltip';
import { AppStyles } from '../styles/AppTheme';
import moment from 'moment';
import { AppConfig } from '../AppConfig';
import { Controller } from '../common/Controller';

export class AppHelper {
  static buttonEdit(caller, current) {
    return (
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForEdit(current)}>edit</i>
        </span>
      </Tooltip>
    )
  }

  static buttonDelete(caller, current) {
    return (
      <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForDelete(current)}>delete</i>
        </span>
      </Tooltip>
    )
  }

  static getPriorityStr = (priority) => {
    let priorityStr = '';
    priority = Number(priority)
    if (priority === 0) {
      priorityStr = 'Very low'
    }
    else if (priority === 1) {
      priorityStr = 'Low'
    }
    else if (priority === 2) {
      priorityStr = 'Medium'
    }
    else if (priority === 3) {
      priorityStr = 'High'
    }
    return priorityStr;
  }

  static arrayToCsv(items) {
    //return items
    if (!items) return null
    let csv = ''
    let index = 0
    for (const item of items) {
      index = index + 1
      if (items.length > index) {
        csv = csv + item + ','
      } else {
        csv = csv + item
      }
    }
    return csv
  }

  static getPlacetype(type) {
    if(!AppConfig.placeTypes) {
      return null
    }
    for(const placeType of AppConfig.placeTypes) {
      if(placeType.key === type) {
        return placeType.name
      }
    }
    return null
  }

  static attachTsToURL = (item) => {
    if (item.cams) {
      for (const cam of item.cams) {
        if(!cam.urlJpeg || cam.urlJpeg.length === 0) 
          continue
        const urlParsed = new urlParser(cam.urlJpeg);
        const currQueryString = (urlParsed.query).substring(1);
        const queryParams = qs.parse(currQueryString);
        queryParams.timestamp = moment().valueOf();
        const modifiedQueryString = qs.stringify(queryParams);
        cam.urlJpeg = urlParsed.origin + urlParsed.pathname + '?' + modifiedQueryString;
      }
    }
    return item;
  }

  static getTags(type) {
    for(const pType of AppConfig.placeTypes) {
      if(pType.key === type) {
        return pType.tags
      }
    }
  }

  static getGlobalPriotiyValue() {
    this.userSettings = Controller.get().userMgr().getUserSettings()
    return Number(this.userSettings.EVENT_VISIBILITY)
  }

  static sortItemsByName(items) {
    if(!items) return []

    return items.sort((a, b) => {
      const str1 = a.name
      const str2 = b.name
      return str1.localeCompare(str2)
    })
  }

}



// WEBPACK FOOTER //
// ./src/helpers/AppHelper.js